import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export interface IClinicStateSlice {
  error: unknown;
  clinicState: IReduxLoadingState;
  clinicList: IClinic[];
  userClinic?: IClinic;
  clinicFloorList: IClinicFloor[];
  loadingFloors: number[];
  selectedFloors: null | number[];
  redirectToUserInfo: boolean;
}

const name = "clinic";

export const initialState: IClinicStateSlice = {
  clinicState: "pending",
  error: "",
  clinicList: [],
  userClinic: undefined,
  clinicFloorList: [],
  loadingFloors: [],
  selectedFloors: null,
  redirectToUserInfo: false,
};

export const clinicSlice = createSlice({
  name,
  initialState,
  reducers: {
    setUserClinic(state, action: PayloadAction<{ clinic: IClinic }>) {
      state.userClinic = action.payload.clinic;
    },
    setRedirectToUserInfo(state, action: PayloadAction<boolean>) {
      state.redirectToUserInfo = action.payload;
    },
    setClinicList(state, action: PayloadAction<{ clinicList: IClinic[] }>) {
      state.clinicList = action.payload.clinicList;
    },
    setClinicFloorList(
      state,
      action: PayloadAction<{ clinicFloorList: IClinicFloor[] }>
    ) {
      state.clinicFloorList = action.payload.clinicFloorList;
      return state;
    },
    setSelectedFloors(state, action: PayloadAction<number[]>) {
      state.selectedFloors = action.payload;
    },
    setClinicState: (
      state,
      action: PayloadAction<Partial<IClinicStateSlice>>
    ) => ({
      ...state,
      ...action.payload,
    }),
    setClinicSliceReset() {
      return initialState;
    },
  },
  extraReducers() {},
});

export const {
  setUserClinic,
  setClinicList,
  setClinicFloorList,
  setSelectedFloors,
  setClinicState,
  setClinicSliceReset,
  setRedirectToUserInfo,
} = clinicSlice.actions;

const persistedReducer = persistReducer(
  {
    key: name,
    storage: storage,
    whitelist: ["selectedFloors", "clinicList", "userClinic"],
  },
  clinicSlice.reducer
);

export default persistedReducer;
